import Nouns from "../../components/ClassTwo/English/Nouns";
import NounsFillBlanks from "../../components/ClassTwo/English/NounsFillBlanks";
import NounsPickup from "../../components/ClassTwo/English/NounsPickup";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/english/nouns/pickup", title: "Pickup Nouns", component: NounsPickup },
    { url: "/class-two/english/nouns/fill-blanks", title: "Fill In the blanks", component: NounsFillBlanks },
];


export default topics;